export default __webpack_public_path__ + "gb.ad51965d.png";